import { Modal, ModalBodyProps } from '@mantine/core';
import clsx from 'clsx';
import { forwardRef } from 'react';

export type ModalFormBodyProps = ModalBodyProps;

export const createModalFormBody = () => {
	const ModalFormBody = forwardRef<HTMLDivElement, ModalFormBodyProps>(
		({ className, children, ...props }, ref) => (
			<Modal.Body
				ref={ref}
				className={clsx('modal-form-body', className)}
				{...props}
			>
				{children}
			</Modal.Body>
		),
	);

	return ModalFormBody;
};
